import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const PersonName = ({ person }: { person: Person }) => {
  const { t } = useTranslation('integrated-messaging');
  return (
    <div
      css={{
        display: 'flex',
        gap: theme.spacing(0.5),
      }}
    >
      {person.firstName && (
        <Text size='large' weight='bold' css={{ color: theme.colorsV2.black(85) }}>
          {person.firstName}
        </Text>
      )}
      {person.lastName && (
        <Text size='large' css={{ color: theme.colorsV2.black(85) }}>
          {person.lastName}
        </Text>
      )}
      {!person.firstName && !person.lastName && (
        <Text size='large' css={{ color: theme.colorsV2.black(85) }}>
          {t('Unknown User')}
        </Text>
      )}
    </div>
  );
};
